// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { TooltipPresentationProps } from "@awc/MobiusOverrides/Tooltip/Tooltip";
import { fontConfig } from "@awc/XDL/PreStyle/typography";
import { xBaseTheme } from "@awc/XDL/types";
import { color } from "@awc/XDL/Utilities";
import Info from "@insite/mobius/Icons/Info";
import { css } from "styled-components";

export default {
    defaultProps: {
        mergeCss: true,
        extendedStyles: {
            tooltipContent: {
                css: css`
                    background-color: ${color("common.ui1")};
                    border-radius: 0;
                    padding: 12px;
                `,
            },
            tooltipArrow: {
                stroke: `${color("common.border")}`,
                fill: `${color("common.ui1")}`,
            },
        },
        iconProps: {
            src: Info,
            size: 16,
            color: "secondary",
        },
        typographyProps: {
            size: fontConfig.fontSize.xSmall,
            weight: fontConfig.weight.regular,
            color: "text.main",
            css: css`
                line-height: ${fontConfig.lineHeight.xSmall};
                text-align: center;
                letter-spacing: 0;
                white-space: break-spaces;
                word-break: break-word;
                &:hover {
                    text-decoration: none;
                }
            `,
        },
    } as TooltipPresentationProps,
} as xBaseTheme["tooltip"];
